import { render, staticRenderFns } from "./AccountingDataEdit.vue?vue&type=template&id=853a524c&scoped=true"
import script from "./AccountingDataEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountingDataEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/components/customers/styles/customer-management-style.css?vue&type=style&index=0&id=853a524c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853a524c",
  null
  
)

/* custom blocks */
import block0 from "@/components/customers/locales/i18n-customer-core-data.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fcustomers%2Fchildren%2FAccountingDataEdit.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports